export const MNEMONICS = [
    { word: "mòr", mem: "Think of the English word 'more'" },
    { word: "beag", mem: "Think of a tiny little bird's 'beak'" },

  ];
  